<template>
<div>
  <el-button style="width:100%;" type="primary" size="small" @click="open">ISO 연결</el-button>
  <w-sliding-popup ref="slidingPopup" title="ISO 연결" top="50px" width="400px" @close="close">
    <div slot="content">
    </div>
    <div slot="footer">
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
export default {
  name: 'WVirtualConnectIsoPopup',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  methods: {
    loadData() {
    },
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/VirtualConnectIsoPopup.vue